import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-79">
      <div className="bg-brand-ivory border-2 border-brand-gold/30 p-6 rounded-xl text-center shadow-md" data-id="element-80">
        <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-3" data-id="element-81">
          Il Tuo Acquisto è Protetto al 100%
        </p>
        <div className="w-14 h-14 mx-auto bg-brand-gold/15 rounded-full flex items-center justify-center mb-4" data-id="element-82">
          <ShieldCheck className="w-7 h-7 text-brand-gold" data-id="element-83" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-extrabold text-brand-navy mb-3 uppercase leading-tight" data-id="element-84">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </h3>
        <div className="text-sm sm:text-base text-brand-text font-medium leading-relaxed space-y-2" data-id="element-85">
          <p data-id="element-86">Il tuo acquisto è completamente senza rischi.</p>
          <p data-id="element-87">
            Hai 14 giorni di tempo per esplorare l'intero sistema, consultare
            tutti i moduli, organizzare i tuoi allenamenti, utilizzare le
            risorse professionali e iniziare ad applicare il sistema con i tuoi
            ginnasti.
          </p>
          <p data-id="element-88">
            Se per qualsiasi motivo non sarai completamente soddisfatto, ti
            basterà contattarci entro 14 giorni e riceverai il rimborso del
            100%.
          </p>
          <p className="font-bold text-brand-navy" data-id="element-89">
            Nessun rischio.
            <br data-id="element-90" />
            Nessuna domanda.
          </p>
        </div>
      </div>
    </section>;
}